import { CategorieSocialePatient, CategorieSocialePatientState } from './types';
import { MutationTree, Module, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';

const namespaced: boolean = true;

export const state: CategorieSocialePatientState = new CategorieSocialePatient();

export const mutations: MutationTree<CategorieSocialePatientState> = {
	mutateCategorieSocialePatient(
		state: CategorieSocialePatientState,
		categorieSocialePatient: CategorieSocialePatient): void {
		state.categorie = categorieSocialePatient.categorie;
		state.categorieDetail = categorieSocialePatient.categorieDetail;
	}
};

export const actions: ActionTree<CategorieSocialePatientState, RootState> = {
	updateCategorieSocialePatient(state, categorieSocialePatient: CategorieSocialePatientState): void {
		state.commit('mutateCategorieSocialePatient', categorieSocialePatient);
	}
};

export const getters: GetterTree<CategorieSocialePatientState, RootState> = {
	getCategorieSocialePatient(state) {
		return state;
	}
};

export const categorieSocialePatient: Module<CategorieSocialePatientState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
